// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import is13GhzBand from 'components/PathDetails/EditForm/sections/Sites/helpers/is13GhzBand'
import { convertDDtoDMSPref } from 'helpers/coordsConversion'
import { valueFromMeters, valueFromKm } from 'helpers/unitConversion'

import {
  castToString,
  roundAndLeaveTrailingZeroes,
} from 'helpers/reduxFormFunctions'

/**
 * Generate Site Data for Path Details form. Used for both Site1/2 and a subset is used
 * to populate passive repeater data.
 * NOTE - for Passive Repeaters, we do not want to track certifiedFlag13Ghz so we just
 * Treat band as null when calling this function.
 * @param s segment
 * @param unitType
 * @param band -
 * @returns {{areaOfOperation: (*|string), azimuth: (*|string), certifiedFlag13Ghz: (boolean|*), companyId: *, companyName: (*|string), contactId: *, county, elevation: (string|string), elevationUnit, latitude: string, longitude: string, segmentEndId, serviceContactCode: (*|string), siteName, stateId: (string|string), radiusKm: (string|string), radiusKmUnit}}
 */
const siteDataForForm = (s, unitType, band = null) => {

  const {
    segmentEndId,
    siteName,
    county,
  } = s

  const areaOfOperation = s.areaOfOperation || ''
  const azimuth = roundAndLeaveTrailingZeroes(s.azimuth, 3) || '-'
  const certifiedFlag13Ghz = is13GhzBand(band) ? s.certifiedFlag13Ghz || false : null
  const companyId = s.company?.companyId || null
  // companyName is displayed on the read only version of the form
  const companyName = s.company?.companyName || ''
  const contactId = s.contact?.contactId || null
  const elevation = castToString(valueFromMeters(s.elevation, unitType))
  const elevationUnit = unitType
  const latitude = convertDDtoDMSPref(s.latitude, 'latitude')
  const longitude = convertDDtoDMSPref(s.longitude, 'longitude')
  const serviceContactCode = s.contact?.contactCode || ''
  const stateId = castToString(s.state?.stateId)
  const radiusKm = castToString(valueFromKm(s.radiusKm, unitType)) || ''
  const radiusKmUnit = unitType

  return {
    areaOfOperation,
    azimuth,
    certifiedFlag13Ghz,
    companyId,
    companyName,
    contactId,
    county,
    elevation,
    elevationUnit,
    latitude,
    longitude,
    segmentEndId,
    serviceContactCode,
    siteName,
    stateId,
    radiusKm,
    radiusKmUnit,
  }
}

export default siteDataForForm
